export enum Currency {
  GBP = 'GBP',
  EUR = 'EUR',
}

export enum CurrencySymbol {
  GBP = '£',
  EUR = '€',
}
